 /*
 * Service: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

 import GentleWidget from '../common/widget';
 import GentleUtil from '../common/util';
 import GentleLang from '../common/lang';
 import GentleComponentButton from '../component/button';
 import GentleComponentBubble from '../component/bubble';
 import GentleComponentQuickReply from '../component/quickReply';
import GentleAppState from '../common/appstate';
import language from '../lang';
import template from '../template/marketingPlan';
 


 var GentleServiceMarketingPlan = Object.create( GentleWidget,{
     sponserId:{ writable: true, configurable: false, enumerable: true},
     sponserName: { writable: true, configurable: false, enumerable: true}
 })
 
 GentleServiceMarketingPlan.main = function(Page){
     const component =  Object.create(this);
     const lang = GentleAppState.lang;
     const {custName} = GentleAppState;
     const render = function(data){
         // 봇버블
         {
             const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.About, {name: custName});
             var bubble = Object.create( GentleComponentBubble );   
             bubble.createComponent({
                     html,
             });
             bubble.insert();
         }
 
         // button
         {
             const text = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.Reward);
             const option = [
                 {
                     send: false,
                     text: text,
                     user: 'user',
                     onClick: function () {
                         aboutReward();
                     },
                 },
             ]
             var button = Object.create( GentleComponentButton);
             button.createComponent(option);
             button.insert();
         }
     };

     const aboutReward = function(){
        // 봇버블
        {
            const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.RewardBot);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.Aim);
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        aboutLevel();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
     }

     const aboutLevel = function(){
        // 봇버블
        {
            const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.AimBot);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.Membership);
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainLevel();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
     }

     const explainLevel = function(){
        // 봇버블
        {
            const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.ExplainLevel);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const html = template.level({lang});

            const $card = $(html);
            $card.find('button').bind('click', function(){
                // todo : 유저 버블... PV가 무엇인가요?
                const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.WhatPV);
                GentleComponentBubble.insertUserBubble({html, send:false})
                explainPV();
            });
            component.insertElement($card);
        }
     }

     const explainPV = function(){
        const lang = GentleAppState.lang.toUpperCase();
        // 봇버블
        {
            const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.ExplainPV);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const html = `
            <div class="card-view">
                <div class="banner-container">
                    <figure class="gentle-banner">
                        <img src = "/assets/images/banner/b8.png" srcset="/assets/images/banner/b8@2x.png 2x">
                    </figure>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">
                            ${lang === GentleLang.lang.KR ? '그럼 소실적 PV는 뭔가요?' : 'So what is smaller leg PV?'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>`;
            const $card = $(html);
            $card.find('button').bind('click', function(){
                const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.WhatSmall);;
                GentleComponentBubble.insertUserBubble({html, send:false});
                explainSmall();
            });
            component.insertElement($card);
        }
     }

     const explainSmall = function(){
         const lang = GentleAppState.lang.toUpperCase();
        // 봇버블
        {
            const html = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.ExplainSmall);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const buttonTitle = GentleLang.translateService(language.marketingPlan, language.marketingPlan.type.GotIt);
            const html = `
            <div class="card-view">
                <div class="banner-container">
                    <figure class="gentle-banner">
                        <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b7.png': 'b7_en.png'}" srcset="/assets/images/banner/${lang === GentleLang.lang.KR ? 'b7@2x.png 2x': 'b7_en@2x.png 2x'}">
                    </figure>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">${buttonTitle}</button>
                        </div>
                    </div>
                </div>
            </div>`;
            const $card = $(html);
            $card.find('button').bind('click', function(){
                GentleComponentBubble.insertUserBubble({html: buttonTitle, send:false})
                explainHuwonsuding();
            });
            component.insertElement($card);
        }
     }

     const explainPosition = function(){    
        const lang = GentleAppState.lang.toUpperCase();             
        // 봇버블
        
            const string = {
                tomy: {
                    kr: {
                        explainPosition: '직급수당도 역시 회사 총 매출 PV 20%에서 회원님의 직급에 따라 지급되는 수당이에요. 등급은 총 7개고, 각 등급을 유지하기 위한 조건이 있습니다.'
                    },
                    eng: {
                        explainPosition: "The mastership bonus is also paid according to the position of the member from 20% of the company's total sales PV. There are 7 grades in total, and there are conditions for maintaining each grade."
                    }
                },
                papa:{
                   kr: {
                    explainPosition: '직급수당도 역시 회사 총 매출 PV 20%에서 본인의 직급에 따라 지급되는 수당이에요. 등급은 총 7개고, 각 등급을 유지하기 위한 조건이 있어요.'
                   },
                   eng: {
                    explainPosition: "The mastership bonus is also paid according to the position of the member from 20% of the company's total sales PV. There are 7 grades in total, and there are conditions for maintaining each grade."
                   }
                }
            }
   
           // 봇버블
           let html;
           const persona = GentleAppState.persona;
           {
               if(persona === GentleLang.persona.TOMMY){
                   html = lang === GentleLang.lang.KR ? 
                   string.tomy.kr.explainPosition
                   : string.tomy.eng.explainPosition; 
               }else{
                    html = lang === GentleLang.lang.KR ? 
                   string.papa.kr.explainPosition
                   : string.papa.eng.explainPosition; 
               }

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }
        {
            const buttonTitle = lang === GentleLang.lang.KR ? '유지 조건이요?': 'maintenance conditions?';
            const html = `
            <div class="card-view">
                <div class="banner-container">
                    <h3>${lang === GentleLang.lang.KR ? '애터미의 직급체계': "Atomy's mastership system"}</h3>
                    <figure class="gentle-banner">
                        <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b6.png': 'b6_en.png'}" srcset="/assets/images/banner/${lang === GentleLang.lang.KR ? 'b6@2x.png 2x': 'b6_en@2x.png 2x'}">
                    </figure>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">${buttonTitle}</button>
                        </div>
                    </div>
                </div>
            </div>`;
            const $card = $(html);
            $card.find('button').bind('click', function(){
                GentleComponentBubble.insertUserBubble({html:buttonTitle, send:false})
                explainLevelCondition();
            });
            component.insertElement($card);
        }
     }

     const explainHuwonsuding = function(){
         
         const lang = GentleAppState.lang.toUpperCase();
       
         const string = {
             tomy: {
                 kr: {
                    explainHuwonsuding: '역시 이해가 빠르시군요! 두 번째, 후원수당은 회사 총 매출 PV 44% 중 회원님께서 취득한 점수만큼 받을 수 있는 수당입니다.'
                 },
                 eng: {
                    explainHuwonsuding: "You understand too! Second, the general commission is an allowance that can be received as much as the points earned by members out of 44% of the company's total sales PV."
                 }
             },
             papa:{
                kr: {
                    explainHuwonsuding: '좋아요! 두 번째, 후원수당이에요. 회사 총 매출 PV 44%에서 본인이 취득한 점수만큼 받을 수 있는 수당이죠.'
                },
                eng: {
                    explainHuwonsuding: "good! Second, the general commission. This is an allowance you can receive as much as the points you have earned from the company's total sales PV of 44%."
                }
             }
         }
        
         



        // 봇버블
        let html;
        const persona = GentleAppState.persona;
        console.log('persona ??? ', persona)
        {
            if(persona === GentleLang.persona.TOMMY){
                html = lang === GentleLang.lang.KR ? 
                string.tomy.kr.explainHuwonsuding
                : string.tomy.eng.explainHuwonsuding; 
            }else{
                 html = lang === GentleLang.lang.KR ? 
                string.papa.kr.explainHuwonsuding
                : string.papa.eng.explainHuwonsuding; 
            }
            

            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            console.log('html >>>>>',html)
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '네, 다음 직급수당은요?' : 'Yes, what about the mastership bonus?';
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainPosition();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        {
            const text = lang === GentleLang.lang.KR ? '후원수당 점수 자세히 알려주세요.' : 'Please tell me the details of the  general commission score.';
            const option = [
                {
                    send: false,
                    isSecondary: true,
                    isHidden: true,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainScore();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
     }

     const explainScore = function(){
        const lang = GentleAppState.lang.toUpperCase();

        const title = lang === GentleLang.lang.KR ? '후원수당 점수 기준' : 'Based on general commission Points';
        const html = template.score({lang});

        GentleUtil.createSlidePopup({
            title,
            content: html,
        });
    }

    const explainLevelCondition = function(){  
        const lang = GentleAppState.lang.toUpperCase();             
        // 봇버블
        
            const string = {
                tomy: {
                    kr: {
                        explainLevelCondition: '크게 두 가지가 있는데요, 먼저 회원님의 직급에 맞는 회원등급을 유지해야 합니다. 그리고 하위 좌우라인 각각 2명 이상이 또 특정 직급을 취득해야 해요.'
                    },
                    eng: {
                        explainLevelCondition: 'There are two main types. First, you must maintain a membership level that is appropriate for your position. And at least two people in each of the lower left and right lines must also acquire a specific mastership.'
                    }
                },
                papa:{
                   kr: {
                    explainLevelCondition: '크게 두 가지가 있는데요, 먼저 본인의 직급에 맞는 회원등급을 유지해야 합니다. 그리고 하위 좌우라인 각각 2명 이상이 또 특정 직급을 취득해야 하죠.'
                   },
                   eng: {
                    explainLevelCondition: 'There are two main types. First, you must maintain a membership level that is appropriate for your position. And at least two people in each of the lower left and right lines must also acquire a specific mastership.'
                   }
                }
            }
   
           // 봇버블
           let html;
           const persona = GentleAppState.persona;
           {
               if(persona === GentleLang.persona.TOMMY){
                   html = lang === GentleLang.lang.KR ? 
                   string.tomy.kr.explainLevelCondition
                   : string.tomy.eng.explainLevelCondition; 
               }else{
                    html = lang === GentleLang.lang.KR ? 
                   string.papa.kr.explainLevelCondition
                   : string.papa.eng.explainLevelCondition; 
               }
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '직급 승급은 어떻게 하나요?' : 'How do I get promoted?';
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainLevelup();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        {
            const text = lang === GentleLang.lang.KR ? '직급별 유지 요건 볼래요' : "Let's see the maintenance conditions by mastership.";
            const option = [
                {
                    isHidden: true,
                    isSecondary: true,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        popupLevelCondition();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }    
    }

    const explainLevelup = function(){
        const lang = GentleAppState.lang.toUpperCase();             
        // 봇버블
        
            const string = {
                tomy: {
                    kr: {
                        explainLevelup: '샤론로즈마스터까지는 유지 요건이 맞다면 언제든 승급 가능합니다. 그다음 스타마스터부터는 전 직급을 3회 이상 유지해야 하죠.'
                    },
                    eng: {
                        explainLevelup: 'You can upgrade to Sharon Rose Master at any time as long as the maintenance requirements are met. From the next Star Master, you must maintain all ranks at least 3 times.'
                    }
                },
                papa:{
                   kr: {
                    explainLevelup: '샤론로즈마스터까지는 유지 요건이 맞다면 언제든 승급할 수 있어요. 그다음 스타마스터부터는 전 직급을 3회 이상 유지해야 승급한답니다.'
                   },
                   eng: {
                    explainLevelup: 'You can upgrade to Sharon Rose Master at any time as long as the maintenance requirements are met. From the next Star Master, you must maintain all ranks at least 3 times to be promoted.'
                   }
                }
            }
   
           // 봇버블
           let html;
           const persona = GentleAppState.persona;
           {
               if(persona === GentleLang.persona.TOMMY){
                   html = lang === GentleLang.lang.KR ? 
                   string.tomy.kr.explainLevelup
                   : string.tomy.eng.explainLevelup; 
               }else{
                    html = lang === GentleLang.lang.KR ? 
                   string.papa.kr.explainLevelup
                   : string.papa.eng.explainLevelup; 
               }
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '승급하면 혜택이 있나요?' : 'Are there any benefits when upgrading?';
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        whatLevelupMerit();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
    }

    const explainEduReward = function(){
        const lang = GentleAppState.lang.toUpperCase();
        // 봇버블
        
        const string = {
            tomy: {
                kr: {
                    explainEduReward: '교육수당은 각 센터 소속회원의 총 매출 PV에서  6%를 지급하는 수당이에요.'
                },
                eng: {
                    explainEduReward: 'The education commission is an allowance paid at 6% of the total sales PV of members belonging to each center. celebration'
                }
            },
            papa:{
               kr: {
                explainEduReward: '교육수당은 각 센터 소속회원의 총 매출 PV에서  6%를 지급하는 수당이에요.'
               },
               eng: {
                explainEduReward: 'The education commission is an allowance paid at 6% of the total sales PV of members belonging to each center. celebration'
               }
            }
        }

       // 봇버블
       let html;
       const persona = GentleAppState.persona;
       {
           if(persona === GentleLang.persona.TOMMY){
               html = lang === GentleLang.lang.KR ? 
               string.tomy.kr.explainEduReward
               : string.tomy.eng.explainEduReward; 
           }else{
                html = lang === GentleLang.lang.KR ? 
               string.papa.kr.explainEduReward
               : string.papa.eng.explainEduReward; 
           }
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                send:false,
                html,
            });
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '4가지 수당 이해했어요.' : 'I understand the 4 allowances.';
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainFaq();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
    }

    const explainFaq = function(){
        const lang = GentleAppState.lang.toUpperCase();             
        // 봇버블
        
            const string = {
                tomy: {
                    kr: {
                        explainFaq: '역시 이해가 빠르시네요! 혹시라도 더 궁금한 게 있다면 아래 버튼을 눌러보세요. 다른 회원분들께서도 궁금해하시는 내용을 준비했습니다.'
                    },
                    eng: {
                        explainFaq: "It's easy to understand too! If you have any further questions, please click the button below. We have prepared information that other members are also curious about."
                    }
                },
                papa:{
                   kr: {
                    explainFaq: '아직은 조금 헷갈릴 수 있어요..^^ 궁금한 게 있다면 언제든 저를 찾아도 돼요. 전 질문을 아주 좋아하거든요.'
                   },
                   eng: {
                    explainFaq: 'It can still be a bit confusing..^^ If you have any questions, you can always find me. I love questions.'
                   }
                }
            }
   
           // 봇버블
           let html;
           const persona = GentleAppState.persona;
           {
               if(persona === GentleLang.persona.TOMMY){
                   html = lang === GentleLang.lang.KR ? 
                   string.tomy.kr.explainFaq
                   : string.tomy.eng.explainFaq; 
               }else{
                    html = lang === GentleLang.lang.KR ? 
                   string.papa.kr.explainFaq
                   : string.papa.eng.explainFaq; 
               }
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '자주하는 질문 보여주세요.' : 'Show me your frequently asked questions.';
            const option = [
                {
                    text: text,
                    user: 'user',
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
    }

    const whatLevelupMerit = function(){
        const lang = GentleAppState.lang.toUpperCase();             
        // 봇버블
        
            const string = {
                tomy: {
                    kr: {
                        whatLevelupMerit: '물론이죠! 우리 회원님의 승급을 축하하는 프로모션을 드립니다. 애터미 제품 제공부터 현금, 자동차, 가족 해외 여행권까지 다양해요.'
                    },
                    eng: {
                        whatLevelupMerit: "Sure! We have a promotion to celebrate our member's promotion. They range from offering Atomy products to cash, cars, and overseas travel vouchers for families."
                    }
                },
                papa:{
                   kr: {
                    whatLevelupMerit: '그럼요^^ 우리 회원님의 승급을 축하하는 프로모션을 드립니다. 애터미 제품 제공부터 현금, 자동차, 가족 해외 여행권까지 다양해요.'
                   },
                   eng: {
                    whatLevelupMerit: "That's right ^^ We're giving away a promotion to celebrate our member's promotion. They range from offering Atomy products to cash, cars, and overseas travel vouchers for families."
                   }
                }
            }
   
           // 봇버블
           let html;
           const persona = GentleAppState.persona;
           {
               if(persona === GentleLang.persona.TOMMY){
                   html = lang === GentleLang.lang.KR ? 
                   string.tomy.kr.whatLevelupMerit
                   : string.tomy.eng.whatLevelupMerit; 
               }else{
                    html = lang === GentleLang.lang.KR ? 
                   string.papa.kr.whatLevelupMerit
                   : string.papa.eng.whatLevelupMerit; 
               }
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // button
        {
            const text = lang === GentleLang.lang.KR ? '좋네요. 교육수당도 알려주세요.' : "It's good. Please tell me about the education commission.";
            const option = [
                {
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        explainEduReward();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        {
            const text = lang === GentleLang.lang.KR ? '프로모션 자세히 알고싶어요.' : 'I want to know more about the promotion.';
            const option = [
                {
                    isSecondary: true,
                    isHidden: true,
                    send: false,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        popupLevelupPromotion();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
    }

    const popupLevelupPromotion = function(){
        const lang = GentleAppState.lang.toUpperCase();
        const title = lang === GentleLang.lang.KR ? '승급 축하 프로모션' : 'promotion celebration';

        const html = template.promotion({lang});

        GentleUtil.createSlidePopup({
            title,
            content: html,
        });
    }

    const popupLevelCondition = function(){
        let lang = GentleAppState.lang;
        lang = lang.toUpperCase();

        const title = lang === GentleLang.lang.KR ? '직급별 유지조건': 'Retention conditions by position';

        const html = template.condition({lang})

        GentleUtil.createSlidePopup({
            title,
            content: html,
        });
    }
 
    render();
 }
 
 export default GentleServiceMarketingPlan;